import React, { useState, useEffect, useMemo } from "react";
import LoaderStyleOne from '../../../components/LoaderStyleOne';
import MUIDataTable from "mui-datatables";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  TextField,
  TableCell,
  Tab,
  Tabs,
  //Select,
  //MenuItem,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { getData, postData } from "../../../ServerRequest";
import SearchIcon from "@mui/icons-material/Search";
import LandscapeIcon from "@mui/icons-material/Landscape";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import CreateTag from "./CreateTag";
import CreateBatch from "./CreateBatch";
import EditTagModal from "./EditTagModal";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function Tags() {
  const [tagsData, setTagsData] = useState([]);
  const [tagsOption, setTagsOption] = useState();
  const [liveTags, setLiveTagsData] = useState([]);
  const [archivedTags, setArchivedTagsData] = useState([]);
  const [deletedTags, setDeletedTagsData] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [counts, setCounts] = useState({
    liveTags: 0,
    archivedTags: 0,
    deletedTags: 0,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editTagData, setEditTagData] = useState(null);
  const [refreshData, setRefreshData] = useState(0);
  const [expanded, setExpanded] = useState(false);

  // Add state for sort
  const [sortColumn, setSortColumn] = useState("updated_on"); // Change to your date field if needed
  const [sortOrder, setSortOrder] = useState("desc");

  // Handler to update tags after batch action
  const handleBatchActionComplete = (data) => {
    setLiveTagsData(data.live_tags || []);
    setArchivedTagsData(data.archived_tags || []);
    setDeletedTagsData(data.deleted_tags || []);
    setTagsData(data.live_tags || []);
    setCounts({
      liveTags: data.live_tags_count || 0,
      archivedTags: data.archived_tags_count || 0,
      deletedTags: data.deleted_tags_count || 0,
    });
  };

  // Helper to sort data
  const sortData = (data, column, order) => {
    if (!data || !Array.isArray(data)) return [];
    return [...data].sort((a, b) => {
      // If sorting by id or tag_id, check both
      if (
        (column === "id" || column === "tag_id") &&
        (a.id || a.tag_id) &&
        (b.id || b.tag_id)
      ) {
        const aId = a.id || a.tag_id;
        const bId = b.id || b.tag_id;
        return order === "desc" ? bId - aId : aId - bId;
      }
      // Default: try to sort as date if possible
      if (!a[column] || !b[column]) return 0;
      if (order === "desc") {
        return new Date(b[column]) - new Date(a[column]);
      } else {
        return new Date(a[column]) - new Date(b[column]);
      }
    });
  };

  // Sort tagsData before filtering
  useEffect(() => {
    let sorted;
    if (
      sortColumn &&
      (selectedTab === 0 || selectedTab === 1 || selectedTab === 2)
    ) {
      sorted = sortData(tagsData, sortColumn, sortOrder);
      setTagsData(sorted);
    }
    // eslint-disable-next-line
  }, [sortColumn, sortOrder, selectedTab]);

  // Enhanced renderSortIcon to always show an icon (copied from Collection.js)
  const renderSortIcon = (columnMeta, sortOrder) => {
    // If this column is sorted, highlight the icon
    if (sortOrder && sortOrder.index === columnMeta.index) {
      return sortOrder.direction === "asc" ? (
        <ArrowUpwardIcon
          style={{ fontSize: 16, marginLeft: 4, color: "#000" }}
        />
      ) : (
        <ArrowDownwardIcon
          style={{ fontSize: 16, marginLeft: 4, color: "#000" }}
        />
      );
    }
    // Not sorted: show faded icon (default to up arrow)
    return (
      <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#ccc" }} />
    );
  };

  // Helper for customHeadRender for sortable columns
  const getCustomHeadRender = (columnMeta, handleToggleColumn, sortOrder) => (
    <TableCell
      key={columnMeta.index}
      style={{
        fontFamily: "inter",
        fontWeight: 600,
        backgroundColor: "#FAFAFB",
        textAlign: "center",
        cursor: "pointer",
      }}
      onClick={() => handleToggleColumn(columnMeta.index)}
    >
      {columnMeta.label}
      {renderSortIcon(columnMeta, sortOrder)}
    </TableCell>
  );

  const handleSaveArchive = async (rowIndex) => {
    // Use filteredData to get the correct row after sort/filter
    const rowToArchive = filteredData[rowIndex];
    const id = rowToArchive.id || rowToArchive.tag_id;
    // Remove from liveTags by id/tag_id
    const updatedLiveTags = liveTags.filter(
      (row) => (row.id || row.tag_id) !== id
    );
    const updatedArchivedTags = [rowToArchive, ...archivedTags];
    setLiveTagsData(updatedLiveTags);
    setArchivedTagsData(updatedArchivedTags);
    setCounts((prevCounts) => ({
      ...prevCounts,
      liveTags: updatedLiveTags.length,
      archivedTags: updatedArchivedTags.length,
    }));
    if (selectedTab === 0) setTagsData(updatedLiveTags);
    try {
      const resData = {
        'id': rowToArchive.id ? rowToArchive.id : "",
        'product_tag': rowToArchive.product_tag ? rowToArchive.product_tag : "",
        'tag_family': rowToArchive.tag_family ? rowToArchive.tag_family : "",
        'category': rowToArchive.tag_category ? rowToArchive.tag_category : "",
        'is_assigned': false,
        'status': 2,
      };
      const res = await postData("/api/product/acc_tag_master", resData);
      if (res["data"]["code"] !== "200") {
        alert("Archive succesfull");
        // Revert state if failed
        setLiveTagsData(liveTags);
        setArchivedTagsData(archivedTags);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveTags: liveTags.length,
          archivedTags: archivedTags.length,
        }));
        if (selectedTab === 0) setTagsData(liveTags);
      }
    } catch (error) {
      alert("Archive failed");
      setLiveTagsData(liveTags);
      setArchivedTagsData(archivedTags);
      setCounts((prevCounts) => ({
        ...prevCounts,
        liveTags: liveTags.length,
        archivedTags: archivedTags.length,
      }));
      if (selectedTab === 0) setTagsData(liveTags);
    }
  };

  const handleSaveRetrieve = async (rowIndex) => {
    const rowToRetrieve = filteredData[rowIndex];
    const id = rowToRetrieve.id || rowToRetrieve.tag_id;
    const updatedArchivedTags = archivedTags.filter(
      (row) => (row.id || row.tag_id) !== id
    );
    const updatedLiveTags = [rowToRetrieve, ...liveTags];
    setArchivedTagsData(updatedArchivedTags);
    setLiveTagsData(updatedLiveTags);
    setCounts((prevCounts) => ({
      ...prevCounts,
      archivedTags: updatedArchivedTags.length,
      liveTags: updatedLiveTags.length,
    }));
    if (selectedTab === 1) setTagsData(updatedArchivedTags);
    try {
      const resData = {
        'id': rowToRetrieve.id ? rowToRetrieve.id : "",
        'product_tag': rowToRetrieve.product_tag ? rowToRetrieve.product_tag : "",
        'tag_family': rowToRetrieve.tag_family ? rowToRetrieve.tag_family : "",
        'category': rowToRetrieve.tag_category ? rowToRetrieve.tag_category : "",
        'is_assigned': true,
        'status': 1,
      };
      const res = await postData("/api/product/acc_tag_master", resData);
      if (res["data"]["code"] !== "200") {
        alert("Retrieve Successfull");
        // Revert state if failed
        setArchivedTagsData(archivedTags);
        setLiveTagsData(liveTags);
        setCounts((prevCounts) => ({
          ...prevCounts,
          archivedTags: archivedTags.length,
          liveTags: liveTags.length,
        }));
        if (selectedTab === 1) setTagsData(archivedTags);
      }
    } catch (error) {
      alert("Retrieve failed");
      setArchivedTagsData(archivedTags);
      setLiveTagsData(liveTags);
      setCounts((prevCounts) => ({
        ...prevCounts,
        archivedTags: archivedTags.length,
        liveTags: liveTags.length,
      }));
      if (selectedTab === 1) setTagsData(archivedTags);
    }
  };

  const handleSaveDelete = async (rowIndex) => {
    const rowToDelete = filteredData[rowIndex];
    const id = rowToDelete.id || rowToDelete.tag_id;
    const updatedLiveTags = liveTags.filter(
      (row) => (row.id || row.tag_id) !== id
    );
    const updatedDeletedTags = [rowToDelete, ...deletedTags];
    setLiveTagsData(updatedLiveTags);
    setDeletedTagsData(updatedDeletedTags);
    setCounts((prevCounts) => ({
      ...prevCounts,
      liveTags: updatedLiveTags.length,
      deletedTags: updatedDeletedTags.length,
    }));
    if (selectedTab === 0) setTagsData(updatedLiveTags);
    try {
      const resData = {
        'id': rowToDelete.id ? rowToDelete.id : "",
        'product_tag': rowToDelete.product_tag ? rowToDelete.product_tag : "",
        'tag_family': rowToDelete.tag_family ? rowToDelete.tag_family : "",
        'category': rowToDelete.tag_category ? rowToDelete.tag_category : "",
        'is_assigned': false,
        'status': 0,
      };
      const res = await postData("/api/product/acc_tag_master", resData);
      if (res["data"]["code"] === "200") {
        alert("Delete successful");
      } else {
        alert("Delete failed");
        // Revert state if failed
        setLiveTagsData(liveTags);
        setDeletedTagsData(deletedTags);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveTags: liveTags.length,
          deletedTags: deletedTags.length,
        }));
        if (selectedTab === 0) setTagsData(liveTags);
      }
    } catch (error) {
      alert("Delete failed");
      setLiveTagsData(liveTags);
      setDeletedTagsData(deletedTags);
      setCounts((prevCounts) => ({
        ...prevCounts,
        liveTags: liveTags.length,
        deletedTags: deletedTags.length,
      }));
      if (selectedTab === 0) setTagsData(liveTags);
    }
  };

  const handleEditClick = (rowData) => {
    // Find the product_tag value from rowData using the column index
    const productTag = rowData[columns.findIndex((col) => col.name === "product_tag")];
    // Find the full tag object in tagsData
    const tag = tagsData.find((row) => row.product_tag === productTag);
    setEditTagData(tag);
    setEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
    setEditTagData(null);
  };

  const handleEditModalSave = async () => {
    setEditModalOpen(false);
    setEditTagData(null);
    setLoading(true);
    setRefreshData((prev) => prev + 1); // Trigger useEffect to refetch data
  };

  // Add this function to handle new tag creation
  const handleTagCreated = (newTag) => {
    // Add new tag to the top of liveTags and tagsData if on live tab
    setLiveTagsData((prev) => [newTag, ...prev]);
    setTagsData((prev) => [newTag, ...prev]);
    setCounts((prevCounts) => ({
      ...prevCounts,
      liveTags: prevCounts.liveTags + 1,
    }));
  };

  useEffect(() => {
    async function fetchData() {
      try {
        let familyRes = await getData("/api/product/acc_tag_family");
        let family_data = familyRes["data"]["tag_families"];
        if (family_data) setFamilyData(family_data);
        let categoryRes = await getData("/api/product/acc_tag_category");
        let category_data = categoryRes["data"]["tag_categories"];
        if (category_data) setCategoryData(category_data);
        let masterRes = await getData("/api/product/acc_tag_master");
        let master_data = masterRes["data"]["tag_masters"];
        let live_tags = masterRes["data"]["live_tags"];
        let archived_tags = masterRes["data"]["archived_tags"];
        let deleted_tags = masterRes["data"]["deleted_tags"];
        // Always sort all tag arrays latest-to-oldest by updated_on (or created_at fallback)
        const sortDesc = (arr) =>
          Array.isArray(arr)
            ? [...arr].sort((a, b) => {
                const aDate = new Date(a.updated_on || a.created_at || 0);
                const bDate = new Date(b.updated_on || b.created_at || 0);
                return bDate - aDate;
              })
            : [];
        if (master_data) {
          const sortedLive = sortDesc(live_tags);
          const sortedArchived = sortDesc(archived_tags);
          const sortedDeleted = sortDesc(deleted_tags);
          setTagsData(sortedLive);
          setLiveTagsData(sortedLive);
          setArchivedTagsData(sortedArchived);
          setDeletedTagsData(sortedDeleted);
          setCounts({
            liveTags: masterRes["data"]["live_tags_count"],
            archivedTags: masterRes["data"]["archived_tags_count"],
            deletedTags: masterRes["data"]["deleted_tags_count"],
          });
          // Always set sortColumn and sortOrder for consistency
          setSortColumn("updated_on");
          setSortOrder("desc");
        } else {
          console.error("Error fetching tag master data:", masterRes.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
    setTagsOption(
      selectedTab === 0
        ? activeOptions
        : selectedTab === 1
        ? archiveOptions
        : deleteOptions
    );
  }, [refreshData]);

  const liveColumns = [
    {
      name: "image_url",
      label: "Image",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div
            style={{
              width: 80,
              height: 52,
              backgroundColor: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0px",
              border: "1px solid #F3F4F6",
              overflow: "hidden",
              margin: "auto",
              textAlign: "center",
            }}
          >
            {value ? (
              <img
                src={value}
                alt="img"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
            )}
          </div>
        ),
      },
    },

    {
      name: "product_tag",
      label: "Product Tag",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "tag_category",
      label: "Tag category",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const category = categoryData.find(
            (cat) =>
              cat.id === value ||
              cat._id === value ||
              cat.value === value ||
              cat.index === value
          );
          return category ? category.category : value;
        },
      },
    },

    {
      name: "tag_family",
      label: "Tag family",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const family = familyData.find(
            (fam) =>
              fam.id === value ||
              fam._id === value ||
              fam.value === value ||
              fam.index === value
          );
          return family ? family.tag_family : value;
        },
      },
    },

    {
      name: "assign_tag",
      label: "Assigned products",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "product_id",
      label: "Actions",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              font: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: "15px",
            }}
          >
            <Tooltip title="Edit">
              <IconButton
                style={{ color: "black" }}
                sx="center"
                onClick={() => handleEditClick(tableMeta.rowData)}
              >
                <EditOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Archive">
              <IconButton
                style={{ color: "black" }}
                sx="center"
                onClick={() => handleSaveArchive(tableMeta.rowIndex)}
              >
                <ArchiveOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                style={{ color: "black" }}
                sx="center"
                onClick={() => handleSaveDelete(tableMeta.rowIndex)}
              >
                <DeleteOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const archivedColumns = [
    {
      name: "image_url",
      label: "Image",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div
            style={{
              width: 80,
              height: 52,
              backgroundColor: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0px",
              border: "1px solid #F3F4F6",
              overflow: "hidden",
              margin: "auto",
              textAlign: "center",
            }}
          >
            {value ? (
              <img
                src={value}
                alt="img"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
            )}
          </div>
        ),
      },
    },

    {
      name: "product_tag",
      label: "Product Tag",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "tag_category",
      label: "Tag category",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const category = categoryData.find(
            (cat) =>
              cat.id === value ||
              cat._id === value ||
              cat.value === value ||
              cat.index === value
          );
          return category ? category.category : value;
        },
      },
    },

    {
      name: "tag_family",
      label: "Tag family",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const family = familyData.find(
            (fam) =>
              fam.id === value ||
              fam._id === value ||
              fam.value === value ||
              fam.index === value
          );
          return family ? family.tag_family : value;
        },
      },
    },

    {
      name: "assign_tag",
      label: "Assigned products",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "assign_tag",
      label: "Retrieve",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              font: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: "15px",
            }}
          >
            <Tooltip title="Live">
              <IconButton
                style={{ color: "black" }}
                sx="center"
                onClick={() => handleSaveRetrieve(tableMeta.rowIndex)}
              >
                <UnarchiveOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Tooltip>
          </div>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
  ];

  const deletedColumns = [
    {
      name: "image_url",
      label: "Image",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div
            style={{
              width: 80,
              height: 52,
              backgroundColor: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0px",
              border: "1px solid #F3F4F6",
              overflow: "hidden",
              margin: "auto",
              textAlign: "center",
            }}
          >
            {value ? (
              <img
                src={value}
                alt="img"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
            )}
          </div>
        ),
      },
    },

    {
      name: "product_tag",
      label: "Product Tag",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "tag_category",
      label: "Tag category",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const category = categoryData.find(
            (cat) =>
              cat.id === value ||
              cat._id === value ||
              cat.value === value ||
              cat.index === value
          );
          return category ? category.category : value;
        },
      },
    },

    {
      name: "tag_family",
      label: "Tag family",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
          getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value) => {
          const family = familyData.find(
            (fam) =>
              fam.id === value ||
              fam._id === value ||
              fam.value === value ||
              fam.index === value
          );
          return family ? family.tag_family : value;
        },
      },
    },

    {
      name: "assign_tag",
      label: "Assigned products",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "assign_tag",
      label: "Delete date",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
  ];

  const columns =
    selectedTab === 0
      ? liveColumns
      : selectedTab === 1
      ? archivedColumns
      : deletedColumns;

  const activeOptions = {
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    print: false, // Disable print
    download: false, // Disable download
    columns: false, // Disable column visibility
    viewColumns: false, // Disable view columns
    filter: false,
    search: false,
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
    selectableRows: "multiple",

    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
      if (action === "rowsSelect") {
        // Use displayData to get the correct visible rows
        const selectedTags = state.selectedRows.data.map((row) => {
          const rowData = state.displayData[row.index].data;
          let tag = rowData.find((cell) => cell && typeof cell === "string");
          return tag || "";
        });
        setSelectedRows(selectedTags);
        console.log("Row selection changed:", selectedTags);
      }
    },
  };

  const archiveOptions = {
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
    selectableRows: "multiple",

    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
      if (action === "rowsSelect") {
        // Use displayData to get the correct visible rows
        const selectedTags = state.selectedRows.data.map((row) => {
          const rowData = state.displayData[row.index].data;
          let tag = rowData.find((cell) => cell && typeof cell === "string");
          return tag || "";
        });
        setSelectedRows(selectedTags);
        console.log("Row selection changed:", selectedTags);
      }
    },
  };

  const deleteOptions = {
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
    selectableRows: "multiple",

    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
      if (action === "rowsSelect") {
        // Use displayData to get the correct visible rows
        const selectedTags = state.selectedRows.data.map((row) => {
          const rowData = state.displayData[row.index].data;
          let tag = rowData.find((cell) => cell && typeof cell === "string");
          return tag || "";
        });
        setSelectedRows(selectedTags);
        console.log("Row selection changed:", selectedTags);
      }
    },
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Always set sortColumn and sortOrder for consistency
    setSortColumn("updated_on");
    setSortOrder("desc");
    // Update tagsData based on the selected tab, always sorted latest-to-oldest
    const sortDesc = (arr) =>
      Array.isArray(arr)
        ? [...arr].sort((a, b) => {
            const aDate = new Date(a.updated_on || a.created_at || 0);
            const bDate = new Date(b.updated_on || b.created_at || 0);
            return bDate - aDate;
          })
        : [];
    if (newValue === 0) {
      setTagsData(sortDesc(liveTags));
      setTagsOption(activeOptions);
    } else if (newValue === 1) {
      setTagsData(sortDesc(archivedTags));
      setTagsOption(archiveOptions);
    } else if (newValue === 2) {
      setTagsData(sortDesc(deletedTags));
      setTagsOption(deleteOptions);
    }
  };

  // Filtered data based on searchQuery and sorted
  const filteredData = useMemo(() => {
    let data = tagsData;
    if (!Array.isArray(data)) return [];
    if (!searchQuery) return data;
    return data
      .filter((row) => row)
      .filter((row) =>
        Object.values(row || {}).some((value) =>
          typeof value === "object"
            ? Object.values(value || {}).some((subValue) =>
                subValue
                  ?.toString()
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
            : value
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
      );
  }, [tagsData, searchQuery]);

  useEffect(() => {
    // Open the batch accordion automatically when rows are selected
    setExpanded(selectedRows.length > 0);
  }, [selectedRows]);

  const handleToggleRow = (tag) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(tag)
        ? prevSelectedRows.filter((row) => row !== tag)
        : [...prevSelectedRows, tag]
    );
  };

  return (
    <>
      <Box sx={{ width: "95%", paddingLeft: 3, mb: 5 }}>
        <Grid container sx={{ flex: 1, height: "100%" }}>
          <Box sx={{ width: "100%", height: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 0,
                mb: 2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontFamily: "Inter", fontWeight: 700, fontSize: 16 }}
              >
                Tag Master
              </Typography>
            </Box>

            {/* Create Tag Section */}
            <CreateTag onTagCreated={handleTagCreated} />

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 2,
                mb: 2,
                gap: 2,
              }}
            >
              {/* Tabs Section */}
              <Box sx={{ height: "36px" }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  sx={{
                    minHeight: "35px",
                    border: "1px solid #F3F4F6",
                    borderRadius: "0px",
                    "& .MuiTabs-flexContainer": {
                      height: "35px",
                    },
                    "& .MuiTab-root": {
                      minHeight: "35px",
                      width: { xs: "120px", sm: "144px" },
                      borderRight: "1px solid #F3F4F6",
                      textTransform: "none",
                      color: "#333",
                    },
                    "& .MuiTab-root:last-of-type": {
                      borderRight: "none",
                    },
                    "& .Mui-selected": {
                      color: "#000 !important",
                    },
                    "& .MuiTabs-indicator": {
                      height: "3px !important",
                      backgroundColor: "#9095A0 !important",
                    },
                  }}
                >
                  <Tab label={`Live Tags (${counts.liveTags})`} />
                  <Tab label={`Archived (${counts.archivedTags})`} />
                  <Tab label={`Deleted (${counts.deletedTags})`} />
                </Tabs>
              </Box>
              {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 'auto' }}>
                            <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 12 }}>
                                View 
                            </Typography>
                        </Box> */}
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                padding: 2,
                paddingLeft: 0,
                mb: 0,
                gap: 4,
                borderTop: "1px solid #BCC1CA",
              }}
            >
              {/* Search Box */}
              <TextField
                sx={{
                  width: { xs: "100%", sm: "304px" },
                  "& .MuiOutlinedInput-root": {
                    height: "35px",
                    borderRadius: "0px",
                  },
                }}
                size="small"
                variant="outlined"
                placeholder="Search by tag, category, family"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <IconButton
                      position="start"
                      sx={{ ml: "-10px", mr: 1, color: "black" }}
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
              {/* Filters */}
              {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                            
                            <Select
                                size="small"
                                sx={{ width: { xs: "100%", sm: "180px" }, height: "35px", borderRadius: "0px" }}
                                value={sortByFamily}
                                onChange={(e) => setSortByFamily(e.target.value)}
                            >
                                <MenuItem value="Tag1">Sort by Family</MenuItem>
                                <MenuItem value="Tag2">Tag2</MenuItem>
                                <MenuItem value="Tag3">Tag3</MenuItem>
                            </Select>
                            
                            <Select
                                size="small"
                                sx={{ width: { xs: "100%", sm: "180px" }, height: "35px", borderRadius: "0px" }}
                            >
                                <MenuItem value="Category1">Filter by Family</MenuItem>
                                <MenuItem value="Category2">Category2</MenuItem>
                                <MenuItem value="Category3">Category3</MenuItem>
                            </Select>
                            
                            <Select
                                size="small"
                                sx={{ width: { xs: "100%", sm: "180px" }, height: "35px", borderRadius: "0px" }}
                            >
                                <MenuItem value="Family1">Family</MenuItem>
                                <MenuItem value="Family2">Family2</MenuItem>
                                <MenuItem value="Family3">Family3</MenuItem>
                            </Select>
                        </Box> */}
            </Box>

            {/* Data Table */}
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                <LoaderStyleOne />
              </div>
            ) : (
              <Box
                sx={{
                  border: "2px solid #F4F3F6",
                  '& div[class*="MUIDataTableToolbar"]': { display: "none" },
                }}
              >
                <MUIDataTable
                  title={""}
                  data={filteredData}
                  columns={columns}
                  options={tagsOption}
                />
              </Box>
            )}

            {/* Batch Action Collapsible */}
            {!loading && (
              <CreateBatch
                selectedRows={selectedRows}
                expanded={expanded}
                setExpanded={setExpanded}
                onToggleRow={handleToggleRow}
                onBatchActionComplete={handleBatchActionComplete}
              />
            )}
          </Box>
        </Grid>
      </Box>

      <EditTagModal
        open={editModalOpen}
        onClose={handleEditModalClose}
        tagData={editTagData}
        onSave={handleEditModalSave}
      />
    </>
  );
}
